import React from "react"

const Switcher = (props) => {
	return <span className={`switcher ${props.isActive ? "active" : ""}`} onClick={() => props.handleUpdate(props)}></span>
}

export default Switcher
